import React, { useRef, useState } from "react";
import "./MyApproach.css";
import { useTranslation } from "react-i18next";

const videos = [
  {
    key: "howIDrive",
    videoSrc: "/videos/how-i-drive.mp4",
    thumbnail: "/thumbnails/how-i-drive.jpg",
  },
  {
    key: "howITeach",
    videoSrc: "/videos/how-i-teach.mp4",
    thumbnail: "/thumbnails/how-i-teach.jpg",
  },
  {
    key: "whatYouLearn",
    videoSrc: "/videos/what-you-learn.mp4",
    thumbnail: "/thumbnails/what-you-learn.jpg",
  },
];

const MyApproach = () => {
  const containerRef = useRef(null);
  const phonesRef = useRef([]);
  const videoRefs = useRef([]);
  const { t } = useTranslation();

  const [playedWithSound, setPlayedWithSound] = useState({});

  const handleMouseEnter = (video) => {
    if (window.innerWidth >= 768 && video.muted) {
      video.play();
    }
  };

  const handleMouseLeave = (video) => {
    if (window.innerWidth >= 768 && video.muted) {
      video.pause();
      video.currentTime = 0;
    }
  };

  const handlePlayClickWithSound = (index) => {
  const video = videoRefs.current[index];
  if (video) {
    video.pause();
    video.currentTime = 0;
    video.muted = false;
    video.setAttribute("controls", true);
    video.classList.add("with-sound");

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          setPlayedWithSound((prev) => ({ ...prev, [index]: true }));

          // Fullscreen on mobile
          if (window.innerWidth < 768) {
            if (video.requestFullscreen) {
              video.requestFullscreen();
            } else if (video.webkitEnterFullscreen) {
              video.webkitEnterFullscreen(); // Safari on iOS
            } else if (video.msRequestFullscreen) {
              video.msRequestFullscreen();
            }
          }
        })
        .catch((err) => {
          console.warn("Autoplay failed:", err);
        });
    }
  }
};

  return (
    <section className="approach-section" ref={containerRef}>
      <h2 className="approach-title">{t("myApproach.title")}</h2>
      <div className="phone-row">
        {videos.map((v, i) => (
          <div
            key={i}
            className="phone-container"
            ref={(el) => (phonesRef.current[i] = el)}
          >
            <div className="phone-frame">
              <video
                className="phone-video"
                muted
                loop
                playsInline
                preload="none"
                poster={v.thumbnail}
                controlsList="nofullscreen"
                ref={(el) => (videoRefs.current[i] = el)}
                onMouseEnter={(e) => handleMouseEnter(e.currentTarget)}
                onMouseLeave={(e) => handleMouseLeave(e.currentTarget)}
              >
                <source src={v.videoSrc} type="video/mp4" />
              </video>

              <img
                src="/frames/phone-frame.svg"
                alt="Phone Frame"
                className="phone-svg-frame"
              />

              {!playedWithSound[i] && (
                <div className="play-button-wrapper">
                  <button
                    className="play-button"
                    onClick={() => handlePlayClickWithSound(i)}
                  >
                    ▶ {t("myApproach.playWithSound")}
                  </button>
                </div>
              )}
            </div>

            <div className="phone-text">
              <div className="phone-title">{t(`myApproach.videos.${v.key}.title`)}</div>
              <p className="phone-description">{t(`myApproach.videos.${v.key}.description`)}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MyApproach;
